class AnimComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { AnimComponentData };
